import { createComponent } from '@front/utils/alpine';

const nav = createComponent(() => ({
    setup () {
        const links = this.$el.querySelectorAll('li a');

        links.forEach((item) => {
            const link = item as HTMLAnchorElement;
            const url = link.href;

            if(window.location.href == url || (window.location.href.indexOf('adresse') > -1 && url.indexOf('adresse') > -1) ) {
                const parent = item.parentNode as HTMLElement;
                const count = item.parentNode?.querySelector('.js-count') as HTMLElement;

                parent.classList.add('outline-gold');
                parent.classList.add('bg-gold');
                parent.classList.add('!text-white');

                count?.classList.add('!bg-white');
                count?.classList.add('!text-gold');
            }
        });
    },
}));

export default {
    nav,
};
